import { ServerFetch } from '../main-model'

export default class StockBalanceModel extends ServerFetch {
    getStockBalanceBy = (data) => this.authFetch({
        url: 'stock-balance/getStockBalanceBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    getProductStockBalanceBy = (data) => this.authFetch({
        url: 'stock-balance/getProductStockBalanceBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
    getProductStockMinimumBy = (data) => this.authFetch({
        url: 'stock-balance/getProductStockMinimumBy',
        method: 'POST',
        body: JSON.stringify(data),
    })

    updateStockBalanceByZone = (data) => this.authFetch({
        url: 'stock-balance/updateStockBalanceByZone',
        method: 'POST',
        body: JSON.stringify(data),
    })
}